// extracted by mini-css-extract-plugin
export default {"logoLink":"Logo-module__logoLink___78vve","logoIcon":"Logo-module__logoIcon___1Cl-l","small":"Logo-module__small___wPlC1","headerExtended":"Logo-module__headerExtended___So3GO"};